import script from "./BookingQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingQuery.vue?vue&type=script&setup=true&lang=js"

import "./BookingQuery.vue?vue&type=style&index=0&id=8139dae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8139dae6"]])

export default __exports__